<template>
  <div class="header_top" data-height="40">
    <slide-up-down
      :active="isOpen"
      :duration="800"
      id="header_top_slider"
      ref="header_top_slider"
    >
      <div class="header_top_outer">
        <div class="header_top_inner">
          <div class="header_top_meta">
            <div class="meta_wrap">
              <router-link
                v-for="item in $mainMenu"
                :to="{ path: (lang ? '/' + lang + '/' : '/') + item.uri }"
                :key="item.slug"
              >
                {{ $t(`mainMenu.${item.slug}`) }}
              </router-link>
              <span id="exch-sep"> | </span>
              <span class="exchange-rate">1$ = {{ exchangeRate }} грн</span>
              <span id="exch-sep"> | </span>
              <a
                href=""
                @click.prevent="changeLocale('ru')"
                :class="{ 'lang-active': $locale === 'ru' }"
                >RU</a
              >
              <a
                href=""
                @click.prevent="changeLocale('ua')"
                :class="{ 'lang-active': $locale === 'ua' }"
                >UA</a
              >
            </div>
          </div>
        </div>
      </div>
    </slide-up-down>
    <div
      :class="`header_top_but ${isOpen ? 'opened' : 'closed'}`"
      @click.stop.prevent="onToggle()"
    >
      <span
        :class="`seasidetms_theme_icon_slide_${isOpen ? 'top' : 'bottom'}`"
      ></span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HeaderTop',
  data() {
    return {
      // initialized: false,
      isOpen: false,
      lang: '',
    }
  },
  computed: {
    ...mapState(['exchangeRate']),
    filterdLocales: function () {
      return this.locales.filter((item) => item != this.$locale)
    },
  },
  methods: {
    changeLocale(locale) {
      let newPathname = ''

      if (locale === 'ru' && this.$locale === 'ua') {
        const { pathname } = window.location
        newPathname = /^\/ru/gm.test(pathname) ? pathname : `/ru${pathname}`
        // newPathname = `/ru${this.$route.path}`

        this.$store.dispatch('changeLang', 'ru')
        this.$locale = locale
        this.$router.push(newPathname)
        this.$lang = locale
      } else if (locale === 'ua' && this.$locale === 'ru') {
        // console.log('to ua')
        // newPathname = this.$route.path.substring(3)
        newPathname = window.location.pathname.substring(3)

        this.$store.dispatch('changeLang', '')
        this.$locale = locale
        this.$router.push(newPathname ? newPathname : '/')
        this.$lang = locale
      }
    },
    onToggle() {
      this.isOpen = !this.isOpen
    },
    fixheaderTop() {
      if (window.innerWidth > 625) {
        // console.log('*[fixheaderTop]', this.isOpen)
        this.$refs.header_top_slider.style.height = '40px'
        this.$refs.header_top_slider.style.display = 'block'
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.fixheaderTop)
      this.fixheaderTop()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.fixheaderTop)
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
.header_top {
  overflow: inherit;
  height: 40px;
}
.lang-active {
  color: #ff4300 !important;
  text-decoration: underline;
}
@media only screen and (max-width: 1024px) {
  /* .header_top {
    height: auto;
  } */
  #exch-sep {
    display: none;
  }
}
@media only screen and (max-width: 625px) {
  .header_top {
    height: auto;
  }
}
</style>
